'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var idToString = exports.idToString = function idToString(id) {
  return '' + id;
};